/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addEmailRestrictions,
  getEmailRestrictions,
} from "../../../../api/User";
import { UserAtom } from "../../../../atoms/UserAtom";
import { UserEmailRestrictionsAtom } from "../../../../atoms/UserEmailRestrictionsAtom";
import StyledBlockInput, { BlockInputType } from "../../../StyledBlockInput";

const validationRegex = /.+\.[A-z]{2}/;

export default function BlockDomain() {
  const [isLoading, setIsLoading] = useState(false);
  const setEmailRestrictions = useSetRecoilState(UserEmailRestrictionsAtom);
  const [user, setUser] = useRecoilState(UserAtom);

  async function handleBlockDomain(domains: string[]) {
    setIsLoading(true);

    try {
      await addEmailRestrictions({ espsBlocked: domains });
      toast("Success", { type: "success" });
      const emailRestrictions = await getEmailRestrictions();
      setEmailRestrictions(emailRestrictions);
      setUser({ ...user, emailRestrictions });
    } catch {
      toast("Error", { type: "error" });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <StyledBlockInput
        isLoading={isLoading}
        inputType={BlockInputType.Domain}
        handleClick={handleBlockDomain}
        placeholder="Domain"
        isValid={(value: string) => {
          const isValid = value.match(validationRegex);
          if (!isValid) return `${value} is not a valid domain.`;
          return "";
        }}
      />
    </>
  );
}
